import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "move-dialog" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row header h-[40px]" }
const _hoisted_4 = { class: "search-wrap" }
const _hoisted_5 = {
  key: 0,
  class: "tree-wrap"
}
const _hoisted_6 = {
  key: 1,
  class: "no-data"
}
const _hoisted_7 = { class: "footer" }

import { ref, watch, onMounted, nextTick } from 'vue'
import { Search } from '@element-plus/icons-vue'
import { ElIcon } from 'element-plus'
import { getFolderTree } from '@/api/affairs'
import { resourceMove, resourceCopy } from '@/api/ResourceMasonry'
import { useUserStore } from '@/stores/user'
import { multipleChoiceStore } from "@/stores/multipleChoice"

export default /*@__PURE__*/_defineComponent({
  __name: 'MoveDialog',
  props: {
  modelValue: { type: Boolean, default: false },
  current: { type: Object, default: () => ({}) },
  teams: { type: Array as () => string[], default: () => [] },
  type: { type: String, default: 'folder' },
  corpCode: { type: String, default: '' },
  resource: { type: Object, default: () => ({}) },
  action: { type: String, default: 'move' },
  multiple: { type: Boolean, default: false }

},
  emits: ['update:modelValue', 'confirm', 'cancel'],
  setup(__props, { emit: __emit }) {

const multipleChoice = multipleChoiceStore()
const userStore = useUserStore()
const props = __props

const emit = __emit

const visible = ref(props.modelValue)
watch(() => props.modelValue, v => visible.value = v)
watch(visible, v => emit('update:modelValue', v))

const selectedTeam = ref(' ')
const keyword = ref('')
const treeRef = ref()
const treeData = ref<any[]>([])
const selectedFolderId = ref<string | number>('')
const showSearch = ref(false)
const searchRef = ref()

const loadTree = async (corpCode?: string) => {
  selectedFolderId.value = ''
  clearSelection()
  try {
    const res = await getFolderTree({ corp_code: corpCode })
    const items = res.data?.data || []
    const normalize = (list: any[]) => list.map(x => ({
      folder_id: x.folder_id ?? x.id,
      name: x.name,
      children: Array.isArray(x.children) ? normalize(x.children) : []
    }))
    treeData.value = normalize(items)
  } catch { }
}
const currentTeam = ref<any>({})
onMounted(() => {
  selectedTeam.value = ' '
  currentTeam.value = userStore.currentTeamInfo || {}
  if (visible.value) loadTree()
})
const onClose = () => {
  selectedTeam.value = ' '
  clearSelection()
}
watch(visible, v => { if (v) loadTree() })

const clearSelection = () => {
  selectedFolderId.value = ''
    ; (treeRef.value as any)?.setCurrentKey?.(null)
}
const onNodeClick = (data: any) => {
  if (selectedFolderId.value === data.folder_id) {
    clearSelection()
  } else {
    selectedFolderId.value = data.folder_id
  }
}
const filterNode = (value: string, data: any) => {
  if (!value) return true
  return String(data.name || '').toLowerCase().includes(String(value).toLowerCase())
}
const onFilter = () => { (treeRef.value as any)?.filter?.(keyword.value) }

const onCancel = () => { visible.value = false; emit('cancel') }
const onConfirm = () => {
  if (props.multiple) {
    multipleConfirm()
    return
  }
  let params = {
    kind: props.type,
    to_owner_type: selectedTeam.value === ' ' ? 'user' : 'team',
    to_corp_code: selectedTeam.value,
    to_folder_id: selectedFolderId.value || undefined,
    from_corp_code: props.corpCode,
    resource_id: props.resource.id,
    folder_id: props.current.folder_id,
    from_owner_type: props.corpCode ? 'team' : 'user',
  }
  if (props.action === 'move') {
    resourceMove(params).then(res => {
      visible.value = false
      emit('confirm', { targetFolderId: selectedFolderId.value, team: selectedTeam.value, current: props.current })
    })
  } else if (props.action === 'copy') {
    resourceCopy(params).then(res => {
      visible.value = false
      emit('confirm', { targetFolderId: selectedFolderId.value, team: selectedTeam.value, current: props.current })
    })
  }

}
const openSearch = async () => {
  showSearch.value = true
  await nextTick()
    ; (searchRef.value as any)?.focus?.()
}
const onSearchBlur = () => {
  showSearch.value = false
}

const onTeamChange = (val: string) => {
  loadTree(val)
}
const multipleConfirm = async () => {
  // folder
  let resource_ids = multipleChoice.selectedResources.join(',')
  let folder_ids = multipleChoice.selectFolder.join(',')
  let params = {
    kind: 'resource',
    to_owner_type: selectedTeam.value === ' ' ? 'user' : 'team',
    to_corp_code: selectedTeam.value,
    to_folder_id: selectedFolderId.value || undefined,
    from_corp_code: props.corpCode,
    resource_id: '',
    folder_id: '',
    from_owner_type: props.corpCode ? 'team' : 'user',
  }
  try {
    if (resource_ids) {
      params.kind = 'resource'
      params.resource_id = resource_ids
      if (props.action === 'move') {
        await resourceMove(params)
      }
      if (props.action === 'copy') {
        await resourceCopy(params)
      }
    }
    if (folder_ids) {
      params.kind = 'folder'
      params.folder_id = folder_ids
      if (props.action === 'move') {
        await resourceMove(params)
      }
      if (props.action === 'copy') {
        await resourceCopy(params)
      }
    }
    emit('confirm')
  } catch {
    emit('confirm')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
    title: __props.action === 'move' ? '移动到...' : '复制到...',
    width: "350",
    "append-to-body": "",
    "close-on-click-modal": false,
    onClose: onClose
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_select, {
            modelValue: selectedTeam.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTeam).value = $event)),
            class: "team-select",
            placeholder: "选择团队",
            teleported: false,
            onChange: onTeamChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "我的空间",
                value: " "
              }),
              _createVNode(_component_el_option, {
                label: currentTeam.value.name,
                value: currentTeam.value.corp_code
              }, null, 8, ["label", "value"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "label" }, "请选择", -1)),
          _createElementVNode("div", _hoisted_4, [
            (showSearch.value)
              ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 0,
                  ref_key: "searchRef",
                  ref: searchRef,
                  modelValue: keyword.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((keyword).value = $event)),
                  placeholder: "搜索",
                  class: "search-input",
                  clearable: "",
                  onInput: onFilter,
                  onBlur: onSearchBlur
                }, null, 8, ["modelValue"]))
              : (_openBlock(), _createBlock(_unref(ElIcon), {
                  key: 1,
                  class: "search-icon",
                  onClick: openSearch
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Search))
                  ]),
                  _: 1
                }))
          ])
        ]),
        (treeData.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_el_tree, {
                ref_key: "treeRef",
                ref: treeRef,
                data: treeData.value,
                "node-key": "folder_id",
                props: { label: 'name', children: 'children' },
                "highlight-current": "",
                onNodeClick: onNodeClick,
                "filter-node-method": filterNode
              }, null, 8, ["data"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, "暂无文件夹")),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_button, { onClick: onCancel }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: onConfirm
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode("确认", -1)
            ]))]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})